import { useState } from 'react';
import close  from '../assests/close.svg';
import menu from '../assests/menu.svg'
import birbawhite from '../assests/birbawhite.png'
import birba from '../assests/birba.png'
import { navLinks } from '../constants/index';
import { Link } from 'react-router-dom';

const Navbars =()=> {
  const [toggle, setToggle] = useState(false);
return(



    <section className=''>
    
      <nav className={`w-full grid grid-cols-2 py-6 px-6 navbar ${ toggle ? "bg-black" : "bg-[#AE0243]"}`} >
      <img src={ birbawhite} alt="hoobank" className="w-[80px] " />
   


<div className='sm:hidden flex flex-1 justify-end items-center'>
<img src={toggle ? close : menu}
  alt='menu'
  className='w-[28px] h-[28px] object-contain mr-4'
  onClick={()=> setToggle((prev)=>!prev)}
/>
<div
className={`${toggle ? 'flex' : 'hidden'}  p-6 bg-black-gradient absolute  -left-4 -top-[2px] mx-4
 min-w[140px] rounded-r-3xl  bg-white`}>

<ul className='list-none flex flex-col justify-end items-center flex-1  rounded-full  '> 
<img src={birba} alt="hoobank" className='w-[60px] -ml-[140px]  mb-10' />
       {navLinks.map((nav,index,link)=>(
        <li key={nav.id} className={`flex flex-row gap-2 font-poppins font-normal cursor-pointer text-[16px] ${index === navLinks.length-1 ? 'mr-0' : 'mb-4'} text-white mr-10`}>
          <div className='w-[40px] h-[40px] bg-[#F3F6FC] rounded-xl mt-[6px]'><img src={nav.img} alt='nav.title'  className='w-[23px] h-[23px] mt-[10px]  ml-2 ' /></div>
          <Link to={nav.link || '/default-link'} className='w-[100px] text-start ml-4 text-[#303030] font-[14px]  mt-[15px]'>{nav.title}</Link>
          
        </li>
       ))}
      </ul>


</div>
</div>
      </nav>
      
      </section>
  )
       }


export default Navbars
